interface ErrorResponse {
    code: number;
    message: string;
}

export interface GenerateSmartBetState {
    generatedSmartBetData: any;
    loading: boolean;
    error: ErrorResponse | null;
}


export enum GenerateSmartBetActionTypes {
    FETCH_GENERATE_SMART_BET_DATA = "FETCH_GENERATE_SMART_BET_DATA",
    FETCH_GENERATE_SMART_BET_DATA_SUCCESS = "FETCH_GENERATE_SMART_BET_DATA_SUCCESS",
    FETCH_GENERATE_SMART_BET_DATA_ERROR = "FETCH_GENERATE_SMART_BET_DATA_ERROR",
}

export type GenerateSmartBetAction =
    | { type: GenerateSmartBetActionTypes.FETCH_GENERATE_SMART_BET_DATA }
    | { type: GenerateSmartBetActionTypes.FETCH_GENERATE_SMART_BET_DATA_SUCCESS; payload: any[] }
    | { type: GenerateSmartBetActionTypes.FETCH_GENERATE_SMART_BET_DATA_ERROR; payload: any };